import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import WorkspaceContainer, {WorkspaceName} from "../table/workspace/WorkspaceContainer";
import Routes from "../../../navigation/route/Route";
import {CellInfo} from "react-table";
import ActionsColumn from "../table/ActionsColumn";
import {WildcardFilterColumnType} from "../../../model/workspace/WildcardFilter";

type Props = RouteComponentProps<any>;

class BillWorkspaceContainer extends React.Component<Props, {}> {
	render() {
		return (
			<WorkspaceContainer workspaceName={WorkspaceName.Bills}
								wildcardFilterColumnType={WildcardFilterColumnType.Bills}
								onRowClick={(rowId: string) => this.props.history.push(Routes.BillDetailsView(rowId))}
								rowToId={(row) => row.id}
								lastColumn={(row: CellInfo) => <ActionsColumn route={Routes.BillDetailsView(row.original.id)}/>}
			/>
		);
	}
}

export default withRouter(BillWorkspaceContainer);
